import { Omit, SelectHelperMenuItem } from 'bold-ui'
import locale from 'bold-ui/lib/i18n/locales/pt-BR'
import { SelectField, SelectFieldProps } from 'components/form'
import { CidadaoAtendimentoSelectFieldModel } from 'components/form/field'
import { CidadaoSelectFieldItem } from 'components/form/field/select/CidadaoSelectField/CidadaoSelectFieldItem'
import { DEFAULT_SELECT_SIZE, useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { CidadaoAtendimentoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  CidadaoAtendimentoSelectFieldQuery,
  CidadaoAtendimentoSelectFieldQueryVariables,
} from 'graphql/types.generated'
import React from 'react'

export interface CidadaoAtendimentoAdSelectFieldProps
  extends Omit<SelectFieldProps<CidadaoAtendimentoSelectFieldModel>, 'items' | 'itemToString'> {
  ativo: boolean
  obito: boolean
  equipeResponsavelId: ID
}

export function CidadaoAtendimentoAdSelectField(props: CidadaoAtendimentoAdSelectFieldProps) {
  const { ativo, obito, equipeResponsavelId, ...rest } = props

  const { skiping, ...asyncProps } = useAsyncQuerySelect<
    CidadaoAtendimentoSelectFieldModel,
    CidadaoAtendimentoSelectFieldQuery,
    CidadaoAtendimentoSelectFieldQueryVariables
  >({
    query: CidadaoAtendimentoSelectFieldDocument,
    extractItems: (data) => data?.cidadaosCombo,
    variables: (inputString) => ({
      input: {
        query: inputString,
        ativo: ativo,
        obito: obito,
        limit: DEFAULT_SELECT_SIZE,
      },
      emAtencaoDomiciliar: true,
      equipeResponsavelId: equipeResponsavelId,
    }),
    skip: (inputString) => inputString?.trim()?.length < 2,
    debounceTime: 500,
  })

  const itemToString = (item: CidadaoAtendimentoSelectFieldModel) => item?.nomeSocial || item?.nome

  const renderItem = (item: CidadaoAtendimentoSelectFieldModel) => {
    return item && <CidadaoSelectFieldItem item={item} />
  }

  return (
    <SelectField<CidadaoAtendimentoSelectFieldModel>
      itemToString={itemToString}
      renderItem={renderItem}
      menuMinWidth={500}
      popperProps={{ modifiers: [{ name: 'preventOverflow', enabled: false }] }}
      components={{
        EmptyItem: () => (
          <SelectHelperMenuItem>
            {skiping ? 'Digite para buscar um cidadão.' : locale.select.emptyItem}
          </SelectHelperMenuItem>
        ),
      }}
      {...asyncProps}
      {...rest}
    />
  )
}
